import React from 'react';
import {
  Building2,
  SquareCheckBig,
  MessageSquare,
  Bell,
  Clock,
  Ellipsis,
  Users,
  BarChart3,
  Settings,
  Scale,
  LifeBuoy,
  LogOut,
  Plus,
  Search,
  Download,
  ArrowUp,
  ArrowDown,
  Check,
  Copy,
  ChevronRight,
  ChevronLeft,
  ChevronDown,
  SearchX,
  X,
  ArrowLeft,
  Ban,
  CirclePlay,
  CircleCheckBig,
  FileText,
  Mail,
  Megaphone,
  ArrowLeftRight,
  LayoutGrid,
  LayoutDashboard,
  Inbox,
  Workflow,
  GitMerge,
  Folder,
  ExternalLink,
  CalendarDays,
  ClipboardList,
  ClipboardCheck,
  TriangleAlert,
  CircleCheck,
  Pencil,
  Eye,
  Save,
  Send,
  Heading2,
  Bold,
  Italic,
  List,
  ListOrdered,
  Link,
  Trash2,
  Dot,
  Paperclip,
  RotateCw,
  CornerUpRight,
  FileCog,
  Layers,
  ShieldCheck,
  FileChartColumn,
  Settings2,
  Lock,
  Receipt,
  RefreshCw,
  CircleX,
  Info,
  Sparkles,
  ArrowRight,
  LoaderCircle,
} from 'lucide-react';
import type { LucideProps } from 'lucide-react';

const ICONS: Record<string, React.ComponentType<LucideProps>> = {
  'building-2': Building2,
  'square-check-big': SquareCheckBig,
  'message-square': MessageSquare,
  bell: Bell,
  clock: Clock,
  ellipsis: Ellipsis,
  users: Users,
  'bar-chart-3': BarChart3,
  settings: Settings,
  scale: Scale,
  'life-buoy': LifeBuoy,
  'log-out': LogOut,
  plus: Plus,
  search: Search,
  download: Download,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  check: Check,
  copy: Copy,
  'chevron-right': ChevronRight,
  'chevron-left': ChevronLeft,
  'chevron-down': ChevronDown,
  'search-x': SearchX,
  x: X,
  'arrow-left': ArrowLeft,
  ban: Ban,
  'circle-play': CirclePlay,
  'circle-check-big': CircleCheckBig,
  'file-text': FileText,
  mail: Mail,
  megaphone: Megaphone,
  'arrow-left-right': ArrowLeftRight,
  'layout-grid': LayoutGrid,
  'layout-dashboard': LayoutDashboard,
  inbox: Inbox,
  workflow: Workflow,
  'git-merge': GitMerge,
  folder: Folder,
  'external-link': ExternalLink,
  'calendar-days': CalendarDays,
  'clipboard-list': ClipboardList,
  'clipboard-check': ClipboardCheck,
  'triangle-alert': TriangleAlert,
  'circle-check': CircleCheck,
  pencil: Pencil,
  eye: Eye,
  save: Save,
  send: Send,
  heading: Heading2,
  bold: Bold,
  italic: Italic,
  list: List,
  'list-ordered': ListOrdered,
  link: Link,
  'trash-2': Trash2,
  dot: Dot,
  paperclip: Paperclip,
  'rotate-cw': RotateCw,
  'corner-up-right': CornerUpRight,
  'file-cog': FileCog,
  layers: Layers,
  'shield-check': ShieldCheck,
  'file-chart-column': FileChartColumn,
  'settings-2': Settings2,
  lock: Lock,
  receipt: Receipt,
  'refresh-cw': RefreshCw,
  'circle-x': CircleX,
  info: Info,
  sparkles: Sparkles,
  'arrow-right': ArrowRight,
  loader: LoaderCircle,
};

export interface IconProps {
  name: keyof typeof ICONS | string;
  size?: number;
  className?: string;
  color?: string;
  strokeWidth?: number;
}

export const Icon = ({
  name,
  size = 20,
  className,
  color,
  strokeWidth = 1.5,
}: IconProps) => {
  const Cmp = ICONS[name];
  if (!Cmp) {
    if (process.env.NODE_ENV !== 'production')
      console.warn(`Icon: unknown name "${name}"`);
    return null;
  }
  return (
    <Cmp
      size={size}
      strokeWidth={strokeWidth}
      className={className}
      color={color}
    />
  );
};
